import React from 'react';
import { ServicePage } from '../ServicePage';

const CONFIG = {
  title: 'Réparation Samsung Villeurbanne / Lyon — Galaxy & A-Series | PHONELAB 69',
  metaDescription: '✅ Réparation Samsung Galaxy Villeurbanne & Lyon. S21/S22/S23/S24, A52/A53/A54. Écran AMOLED, batterie, connecteur. Express 30min. Garantie 12 mois. ☎ 04 26 00 82 10',
  icon: '📲',
  badge: 'Spécialiste Samsung — Villeurbanne / Lyon',
  h1: 'Réparation Samsung\nVilleurbanne & Lyon',
  subtitle: 'Samsung Galaxy toutes séries réparés en express. Écrans AMOLED certifiés, pièces en stock, garantie jusqu\'à 12 mois.',
  stats: [
    { icon: '⚡', label: 'Écran en 30 min' },
    { icon: '🛡️', label: 'Garantie 12 mois' },
    { icon: '✅', label: 'Diagnostic GRATUIT' },
    { icon: '📺', label: 'Écrans AMOLED' },
  ],
  servicesTitle: 'Réparations Samsung disponibles à Villeurbanne',
  services: [
    { icon: '📺', name: 'Écran Samsung Galaxy (AMOLED)', models: 'S21, S22, S23, S24, S24+, S24 Ultra', duration: '30-45 min' },
    { icon: '📺', name: 'Écran Samsung A-Series', models: 'A52, A53, A54, A34, A14, A25, A55', duration: '20-30 min' },
    { icon: '🔋', name: 'Remplacement batterie Samsung', models: 'Toutes séries Galaxy — batterie certifiée', duration: '20-30 min' },
    { icon: '⚡', name: 'Connecteur de charge USB-C', models: 'Problèmes de charge, câble qui tient mal', duration: '20-30 min' },
    { icon: '📷', name: 'Réparation caméra Samsung', models: 'Module caméra avant, arrière, zoom', duration: '30-45 min' },
    { icon: '🔲', name: 'Vitre arrière Samsung', models: 'Remplacement en cas de bris', duration: '30-60 min' },
    { icon: '🔧', name: 'Micro-soudure carte mère', models: 'Problèmes alimentation, Wi-Fi, signal', duration: '24-48h' },
    { icon: '💧', name: 'Désoxydation Samsung noyé', models: 'Nettoyage ultrason professionnel', duration: '1-2h' },
    { icon: '🔊', name: 'Haut-parleur & micro Samsung', models: 'Problèmes audio, appels silencieux', duration: '20 min' },
  ],
  guarantee: {
    duration: 'Garantie 12 mois',
    label: 'Pièces d\'origine ou premium',
    speed: 'Express 20-45 min',
  },
  faq: [
    {
      q: 'Combien coûte la réparation d\'un écran Samsung à Villeurbanne ?',
      a: 'Le tarif varie selon la série (Galaxy S ou A) et la qualité d\'écran. Les écrans AMOLED d\'origine sont plus chers mais offrent une qualité identique à l\'origine. Diagnostic et devis 100% gratuits — appelez le 04 26 00 82 10 ou passez directement.',
    },
    {
      q: 'Réparez-vous les Samsung Galaxy S23, S24 et les modèles récents ?',
      a: 'Oui, PHONELAB 69 répare les modèles récents Samsung : Galaxy S23, S23+, S23 Ultra, S24, S24+, S24 Ultra. Pour les modèles très récents, les pièces peuvent être commandées sous 24-48h.',
    },
    {
      q: 'La réparation Samsung est-elle garantie ?',
      a: 'Oui. Garantie 12 mois sur les pièces d\'origine, 6 mois sur les compatibles premium. Si votre appareil est immobilisé plus de 7 jours, la garantie est automatiquement prolongée (Art. L217-11 Code Consommation).',
    },
    {
      q: 'Peut-on réparer un Samsung avec l\'écran qui scintille ou a des lignes ?',
      a: 'Oui. Les lignes colorées ou le scintillement sur un écran Samsung indiquent généralement une dalle endommagée ou un connecteur lâche. Notre diagnostic gratuit détermine la cause exacte avant tout remplacement.',
    },
  ],
  ctaTitle: 'Votre Samsung réparé aujourd\'hui',
  ctaSubtitle: 'Sans rendez-vous · Expert Samsung · Diagnostic gratuit',
};

export default function SamsungPage() {
  return <ServicePage config={CONFIG} />;
}
